module.exports = __webpack_public_path__ + "static/media/rchx.186a737d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/rchx.png
// module id = 679
// module chunks = 0 1